export default __webpack_public_path__ + "static/media/minus-icon.2b531333.svg";